import React, { useEffect, useState } from 'react';
import DynamicWaffleChart from '../components/dynamic-chart';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { GET_PUBLIC_WIDGET, GET_PUBLIC_WIDGET_WAFFLE } from '../../../../constants/endpoints';

const WaffleWidget = () => {
       const params = useParams();
        const widget_id = params?.widget_id;
        const target_id = params?.target_id;
        const [campaignDetail, setCampaignDetail] = useState({});
        const [goal, setGoal] = useState(1000);
        const [units, setUnits] = useState(0);
        const [loader, setLoader] = useState(true);
    const getCampaignDetail = () => {
        setLoader(true);
        const publicAxios = axios.create({ withCredentials: false });
        publicAxios.get(`${GET_PUBLIC_WIDGET_WAFFLE}${target_id}/${widget_id}/waffle`)
            .then((res) => {
                setLoader(false);
                if (res?.data?.status) {
                    setCampaignDetail(res?.data?.response);
                    setGoal(parseFloat(res?.data?.response?.goal_amount) > 0 ? parseFloat(res?.data?.response?.goal_amount) : 1000);
                    setUnits(res?.data?.response?.available_units ? parseFloat(res?.data?.response?.goal_amount) - parseFloat(res?.data?.response?.available_units) : 0);
                }
            }).catch((error) => {
                setLoader(false);
            })
    }
    useEffect(() => {
            getCampaignDetail();
        }, [])

    useEffect(() => {
    const sendHeight = () => {
      const height = document.body.scrollHeight;
      window.parent.postMessage(
        { 
          type: 'WAFFLE_WIDGET_RESIZE', 
          height: height 
        },
        '*'
      );
    };

    sendHeight();
    const resizeObserver = new ResizeObserver(() => {
      sendHeight();
    });

    resizeObserver.observe(document.body);

    window.addEventListener('resize', sendHeight);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', sendHeight);
    };
  }, [campaignDetail, loader]);
        
    return (
        <>
        {!loader ?
            <div className="p-2">
                <style>{`
        html .bg-white,
          body .bg-white {
              background: transparent !important;
          }
        .sponsor-widget {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }
        
        .sponsor-title {
          color: #0047AB;
          font-weight: 700;
          font-size: clamp(1.5rem, 3vw, 1.6rem);
          text-align: center;
          margin-bottom: 0.6rem;
          letter-spacing: 0.5px;
        }
        
        .info-card {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          padding: clamp(0.5rem, 2vw, 1rem);
          margin-bottom: 0.7rem;
        }
        
        .info-title {
          color: #0047AB;
          font-weight: 600;
          font-size: clamp(1rem, 3.5vw, 1.25rem);
          text-align: center;
          margin-bottom: 0.3rem;
          text-transform: uppercase;
        }
        
        .info-description {
          color: #0047AB;
          font-size: clamp(0.9rem, 1.8vw, 0.9rem);
          text-align: center;
          margin-bottom: 0;
        }
        
        .stats-container {
          display: flex;
          gap: clamp(0.5rem, 2vw, 1rem);
          margin-bottom: 0.7rem;
          flex-wrap: wrap;
          justify-content: center;
        }
        
        .stat-box {
          background: #ffffff;
          border-radius: 15px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          padding: clamp(0.5rem, 1.5vw, 0.7rem);
          flex: 1;
          min-width: 120px;
          max-width: 180px;
        }
        
        .stat-number {
          font-size: clamp(2rem, 3.5vw, 2.5rem);
          font-weight: 700;
          margin-bottom: 0.25rem;
          line-height: 1;
        }
        
        .stat-number.total {
          color: #0047AB;
        }
        
        .stat-number.sponsored {
          color: #009000;
        }
        
        .stat-number.remaining {
          color: #ff0000;
        }
        
        .stat-label {
          font-size: clamp(0.75rem, 2vw, 0.875rem);
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .stat-label.total {
          color: #0047AB;
        }
        
        .stat-label.sponsored {
          color: #009000;
        }
        
        .stat-label.remaining {
          color: #ff0000;
        }
        
        .donate-btn {
          background: #009000;
          color: white;
          border: none;
          border-radius: 5px;
          padding: clamp(0.2rem, 1vw, 0.4rem) clamp(0.5rem, 1.5vw, 1rem);
          font-size: clamp(1.8rem, 2vw, 1.8rem);
          font-weight: 700;
          text-transform: uppercase;
          width: 180px;
          cursor: pointer;
          transition: background 0.3s ease;
          box-shadow: 0 4px 12px rgba(0, 170, 0, 0.3);
          letter-spacing: 1px;
        }
        
        .donate-btn:hover {
          background: #009900;
          box-shadow: 0 6px 16px rgba(0, 170, 0, 0.4);
          color: white;
        }
        
        .footer {
          text-align: center;
          margin-top: 0.5rem;
        }
        
        .logo-placeholder {
        //   width: clamp(60px, 15vw, 80px);
        //   height: clamp(60px, 15vw, 80px);
        //   background: #000000;
          margin: 0 auto;
          border-radius: 8px;
        }
        
        .powered-text {
          color: #666666;
          font-size: clamp(0.75rem, 2vw, 0.875rem);
        }
        
        .powered-brand {
          color: #333333;
          font-weight: 600;
          font-size: clamp(0.875rem, 2.5vw, 1rem);
        }
        
        @media (max-width: 400px) {
          .stats-container {
            flex-direction: row;
          }
          
          .stat-box {
            flex: 1 1 calc(33.333% - 0.5rem);
            min-width: 90px;
          }
        }
      `}</style>

                <div className="sponsor-widget">
                    <h1 className="sponsor-title text-uppercase">{campaignDetail?.campaign_title}</h1>

                    <div className="info-card">
                        <h2 className="info-title text-uppercase">{campaignDetail?.featured_campaign_desc}</h2>
                        <p className="info-description">
                            {campaignDetail?.subtitle}
                        </p>
                        <DynamicWaffleChart total={goal} filled={units} style={{ width: '100%', height: '350px', marginTop:'0.3rem' }} />
                    </div>

                    <div className="stats-container">
                        <div className="stat-box text-center">
                            <div className="stat-number total">{goal}</div>
                            <div className="stat-label total">Total</div>
                        </div>

                        <div className="stat-box text-center">
                            <div className="stat-number sponsored">{units}</div>
                            <div className="stat-label sponsored">Sponsored</div>
                        </div>

                        <div className="stat-box text-center">
                            <div className="stat-number remaining">{goal - units}</div>
                            <div className="stat-label remaining">Remaining</div>
                        </div>
                    </div>
                    <div className='text-center'>
                    <a className="donate-btn btn mb-2 mt-2" target='_blank' href={`${campaignDetail?.organization?.organization_short_name ?
                          campaignDetail?.organization?.organization_short_name : 'masjid'
                          }/product/${campaignDetail?.donation_page_link}`}>DONATE</a></div>

                    <div className="footer">
                        <div className="logo-placeholder"><img src='/img/masjid/masjidal-new-logo.png' style={{
                                height: 'calc(2.3vw + 2.3vh)',
                                height: 'calc(2.9vw + 2.9vh)',
                                padding: 'calc(0.2vw + 0.2vh)'
                            }}/></div>
                        <div className="powered-text">Powered by <a className="powered-brand" target='_blank' href='https://www.masjidal.com'>Masjidal</a></div>
                    </div>
                </div>
            </div>
            : ''}
        </>
    );
};

export default WaffleWidget;